module.exports = __webpack_public_path__ + "img/no-signups.68f73d30.png";